import { z } from 'zod';
import { objectIdSchema, paginationSchema } from './common.js';
export const createMessageTemplateSchema = z.object({
    chatId: objectIdSchema,
    name: z.string().min(1).max(100),
    body: z.string().min(1).max(4096),
});
export const updateMessageTemplateSchema = z.object({
    name: z.string().min(1).max(100).optional(),
    body: z.string().min(1).max(4096).optional(),
});
export const messageTemplateIdParamSchema = z.object({
    id: objectIdSchema,
});
export const messageTemplateListQuerySchema = paginationSchema.extend({
    chatId: objectIdSchema.optional(),
});
//# sourceMappingURL=message-template.js.map